import {
    CButton,
    CCardTitle,
    CCol,
    CContainer,
    CForm,
    CFormInput,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CRow,
} from '@coreui/react';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { UserStatus } from '@/utils/constants.js';

import { useLocationStore, useTodaysAppointmentsStore } from '@/zustandStore.js';

const LegacyManualCheckinModal = ({
    showLegacyManualCheckinModal,
    manualCheckinPatientName,
    setManualCheckinPatientName,
    startCheckin,
    appointment,
}) => {
    const { t } = useTranslation();
    const appointmentTicketNumber = useTodaysAppointmentsStore((state) => state.appointmentTicketNumber);
    const selectedLocation = useLocationStore((state) => state.selectedLocation);

    const config = useMemo(() => {
        if (!appointment || appointment.user_status === UserStatus.UNKNOWN) return selectedLocation.dcConfig;
        return selectedLocation.configs.find((c) => c.instance_id[0].text === appointment.links.dc_instance_id);
    }, [selectedLocation, appointment]);

    useEffect(() => {
        if (showLegacyManualCheckinModal) {
            const patientName = `${appointment.patient?.name.first_name} ${appointment.patient?.name.last_name}`;

            setManualCheckinPatientName(patientName);
        }
    }, [showLegacyManualCheckinModal]);

    return (
        <CModal
            scrollable
            visible={showLegacyManualCheckinModal}
            onClose={() => useTodaysAppointmentsStore.setState({ showLegacyManualCheckinModal: false })}
        >
            <CModalHeader />
            <CModalBody lg={12} md={12} sm={12} xs={12}>
                <CContainer style={{ marginTop: 10, marginBottom: 10 }}>
                    <h3>{t('Manual Checkin')}</h3>
                    <CRow xs={{ gutterY: 0 }}>
                        <CCol lg={12} md={12} sm={12} xs={12}>
                            <CCardTitle style={{ fontSize: 14 }}> {t('Please enter the patient`s name')} </CCardTitle>
                        </CCol>
                        <CCol lg={12} md={12} sm={12} xs={12}>
                            <CForm>
                                <div className="mb-3">
                                    <CFormInput
                                        type="text"
                                        value={manualCheckinPatientName}
                                        placeholder={`${t('Patient name')}`}
                                        name="name"
                                        onChange={(e) => setManualCheckinPatientName(e.target.value)}
                                    />
                                </div>
                            </CForm>
                        </CCol>
                        {config.is_patient_call_system_active && (
                            <>
                                <CCol lg={12} md={12} sm={12} xs={12}>
                                    <CCardTitle style={{ fontSize: 14 }}>
                                        {' '}
                                        {t('Assign the visitor a unique code to check-in')}{' '}
                                    </CCardTitle>
                                </CCol>
                                <CCol lg={12} md={12} sm={12} xs={12}>
                                    <CForm>
                                        <div className="mb-3">
                                            <CFormInput
                                                type="text"
                                                value={appointmentTicketNumber[appointment?.id]}
                                                placeholder={`${t('Call number')}`}
                                                name="number"
                                                onChange={(e) =>
                                                    useTodaysAppointmentsStore.setState({
                                                        appointmentTicketNumber: {
                                                            ...appointmentTicketNumber,
                                                            [appointment?.id]: e.target.value,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                    </CForm>
                                </CCol>
                            </>
                        )}
                    </CRow>
                </CContainer>
            </CModalBody>

            <CModalFooter>
                <CButton
                    color="light"
                    onClick={() => useTodaysAppointmentsStore.setState({ showLegacyManualCheckinModal: false })}
                >
                    {t('Close')}
                </CButton>
                <CButton
                    disabled={
                        (config.is_patient_call_system_active && !appointmentTicketNumber[appointment?.id]) ||
                        !manualCheckinPatientName
                    }
                    onClick={() => {
                        startCheckin();
                        useTodaysAppointmentsStore.setState({ showLegacyManualCheckinModal: false });
                    }}
                    color="secondary"
                >
                    {t('Save Changes')}
                </CButton>
            </CModalFooter>
        </CModal>
    );
};

export default LegacyManualCheckinModal;
